// @flow
import * as React from "react";
import Gettext from "./Gettext";

type Props = {
  className?: string,
  style?: { [key: string]: mixed }
};

const Refund = ({ className, style }: Props) => (
  <span style={{ textTransform: "uppercase", ...style }}>
    <Gettext>refund</Gettext>
  </span>
);

export default Refund;



// WEBPACK FOOTER //
// ./src/components/common/Refund.js